import DashboardLayout from '../layouts/DashboardLayout';
export const errorProductMenu = {
    path: '/error-product',
    component: DashboardLayout,
    name: 'ErrorProduct',
    children: [
        {
            path: '/error-product',
            component: () => import (/* webpackChunkName: "about" */'../pages/errorProduct/ErrorProduct'),
            name: 'ErrorProduct',
            meta: {
                roles: ['contact_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Báo lỗi sản phẩm'
                }]
            },
        }
    ],
}